var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchNew = function SvgSearchNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.302 12.861a.554.554 0 0 1-.396-.165l-2.561-2.561a5.624 5.624 0 0 1-3.57 1.274A5.642 5.642 0 0 1 .139 5.774 5.642 5.642 0 0 1 5.776.138a5.642 5.642 0 0 1 5.635 5.636 5.657 5.657 0 0 1-1.274 3.571l2.562 2.561a.558.558 0 0 1-.397.955zM5.774 1.258a4.522 4.522 0 0 0-4.517 4.517 4.522 4.522 0 0 0 4.518 4.517 4.522 4.522 0 0 0 4.517-4.517 4.523 4.523 0 0 0-4.518-4.517z"
  })));
};
export default SvgSearchNew;